const inFlight = new Map();

export function resetVqqCreateSingleFlightForTests() {
  inFlight.clear();
}

function normalizePart(value) {
  return String(value ?? "")
    .trim()
    .toLowerCase();
}

function normalizeDueBy(dueBy) {
  if (dueBy == null) return "";
  if (dueBy instanceof Date) return dueBy.toISOString();
  return String(dueBy);
}

export function vqqCreateRequestKey(purchaseVendorId, data) {
  return JSON.stringify({
    id: purchaseVendorId,
    provider_id: normalizePart(data?.provider_id),
    template_id: normalizePart(data?.template_id),
    template_name: normalizePart(data?.template_name),
    location_city: normalizePart(data?.location_city),
    location_state: normalizePart(data?.location_state),
    due_by: normalizeDueBy(data?.due_by),
  });
}

export function shareVqqCreate(key, start) {
  const pending = inFlight.get(key);
  if (pending) return pending;

  let tracked;
  try {
    tracked = Promise.resolve(start());
  } catch (error) {
    return Promise.reject(error);
  }

  const shared = tracked.finally(() => {
    if (inFlight.get(key) === shared) inFlight.delete(key);
  });
  inFlight.set(key, shared);
  return shared;
}
